import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=42494416&scoped=true"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"
import style0 from "./Organ.vue?vue&type=style&index=0&id=42494416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42494416",
  null
  
)

export default component.exports